const appRoles = {
  vci: 'vci',
  tool_user: 'tool_user',
  user: 'user',
  readonly: 'readonly',
  billing_manager: 'billing_manager',
};

export default appRoles;
